module.exports = __webpack_public_path__ + "media/images/experiences/bio-9c1bd42f191e88b7f73edda88266a617.jpg";